import { toast } from "react-toastify";
import { addNotification } from "../../redux/actions/dashboard/dashboardActions";
import { adjustUnreadNotificationsCout } from "../../redux/actions/profile/profileActions";
import store from "../../redux/reduxStore";
import router from "../../core/routes";

function receiveNotificationEvent(data) {
  store.dispatch(adjustUnreadNotificationsCout({ count: 1 }));
  store.dispatch(addNotification(data.notification));

  toast.info(`${data.notification.message}`, {
    position: "top-center",
    autoClose: 3000,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    onClick: () => {
      router.navigate(`/dashboard/notifications`);
    },
  });
}

export default receiveNotificationEvent;
